import { SVGIcon } from '@superops/super-icons';
import { Button } from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';

const EditIconWrap = styled.div`
  padding: ${(props) => props.padding || '0 5px'};
`;

export function EditIcon({ size, color, onClick, ...props }) {
  return (
    <EditIconWrap {...props} className={null}>
      <Button
        plain
        onClick={onClick}
        icon={<SVGIcon name="Edit" size={size} color={color} />}
      />
    </EditIconWrap>
  );
}
